import { z } from "zod";

export const waitModeOptions = ["wait_all", "wait_any"] as const;

export const waitNodeSchema = z.object({
  mode: z.enum(waitModeOptions, {
    error: (issue) =>
      issue.input === undefined ? "Selecciona un modo de espera" : undefined,
  }),
  timeoutValue: z
    .number({
      error: (issue) =>
        issue.input === undefined
          ? "Ingresa un tiempo de espera"
          : "Ingresa un número válido",
    })
    .min(1, "El tiempo debe ser mayor a 0"),
  timeoutUnit: z.enum(
    ["minute", "hour", "day", "week", "month", "year"] as const,
    {
      error: (issue) =>
        issue.input === undefined
          ? "Selecciona una unidad de tiempo"
          : undefined,
    },
  ),
});

export type WaitNodeFormData = z.infer<typeof waitNodeSchema>;
